export const RESET = 'CONTACT_LIST_RESET'
export const SET_ITEMS = 'CONTACT_LIST_SET_ITEMS'
export const SET_ERROR = 'CONTACT_LIST_SET_ERROR'
export const SET_VIEW = 'CONTACT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'CONTACT_LIST_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/contact/list/mutation_types.js